import { useNavigate, useParams } from 'react-router-dom';
import { PageOuterContainer } from '../../../../root-components/layouts/page-outer-container'
import { IPostReleaseNote, IReleaseNote } from '../../../../shared/services/release-notes/release-notes-model';
import { PageHeading } from '../../../presentation-components/display-elements-components/page-heading'
import ReleaseNotesService from '../../../../shared/services/release-notes/release-notes-service';
import { useContext, useEffect, useState } from 'react';
import { UserNotificationsContext } from '../../../../context/user-notifications/user-notifications';
import { ReleaseNoteForm } from '../../../presentation-components/super-admin/super-admin-release-note-form';
import { LoadingPage } from '../../loading-page';
import { IconName } from '../../../../shared/interfaces/icon-picker.model';

export const SuperAdminEditReleaseNotePage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  //Services
  const releaseNotesService = new ReleaseNotesService();
  //Context
  const userNotificationsContext = useContext(UserNotificationsContext);
  //State
  const [releaseNote, setReleaseNote] = useState<IReleaseNote>();
  const [errorMessage, setErrorMessage] = useState<string>();
  const [errorCode, setErrorCode] = useState<number>();
  const [editField, setEditField] = useState<string>('');
  //Loading State
  const [isFormSubmitting, setIsFormSubmitting] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  //Use Effects

  useEffect(() => {
    if (id) {
      getReleaseNote(id);
    }
  }, [id]);

  const getReleaseNote = (id: string) => {
    releaseNotesService.getOne(id)
      .then(response => {
        setReleaseNote(response);
        setIsLoading(false);
      })
      .catch(err => {
        console.log(err);
        setIsLoading(false);
      });
  }

  const submitHandler = async (payload: { values: IPostReleaseNote, files: File[], removedResourceIds: string[] }) => {
    if (id && payload?.values) {
      if (!isFormSubmitting) {
        setIsFormSubmitting(true);
        const form = new FormData();
        if (payload.files && payload.files.length > 0) {
          for (let i = 0; i < payload.files.length; i++) {
            form.append('files', payload.files[i]);
          }
        }
        form.append('releaseNote', JSON.stringify(payload.values));
        if (payload.removedResourceIds && payload.removedResourceIds.length > 0) {
          form.append('removedResourceIds', JSON.stringify(payload.removedResourceIds));
        }
        releaseNotesService.edit(id, form)
          .then(response => {
            getReleaseNote(response.id!);
            setEditField('');
            userNotificationsContext.openSnackbar({ open: true, message: 'Updated successfully' });
            setIsFormSubmitting(false);
          })
          .catch(err => {
            if (err.response.data.message) {
              setErrorMessage(err.response.data.message);
              setErrorCode(err.response.data.code);
              userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
            } else {
              userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
            }
          })
      }
    }
  }

  const deleteHandler = (id: string) => {
    if (id) {
      userNotificationsContext.openDialog({ active: true, title: 'Confirmation', message: `Are you sure you want to delete this release note? This action cannot be undone.`, buttonCopy: 'Continue', cancelButtonCopy: 'Cancel' })
        .then(response => {
          if (response) {
            if (!isFormSubmitting) {
              setIsFormSubmitting(true);
              releaseNotesService.delete(id)
                .then(response => {
                  navigate('/super-admin/release-notes');
                  userNotificationsContext.openSnackbar({ open: true, message: 'Deleted successfully' });
                  setIsFormSubmitting(false);
                })
                .catch(err => {
                  console.log(err);
                  userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
                  setIsFormSubmitting(false);
                });
            }
          }
        })
    }
  }

  return (
    <PageOuterContainer>
      {releaseNote &&
        <PageHeading
          title={releaseNote?.title}
          includeBackButton={true}
          backButtonLink={`/super-admin/release-notes`}
          backButtonText={`Back to release notes`}
          includeActionButton={true}
          actionButtonIcon={IconName.DeleteOutline}
          actionButtonHandler={() => deleteHandler(releaseNote.id)}
          actionButtonText='Delete'
        />}
      <LoadingPage pageReady={!isLoading}>
        <ReleaseNoteForm
          newReleaseNote={{
            title: releaseNote?.title || '',
            description: releaseNote?.description || '',
            status: releaseNote?.status || '',
            releasedDate: releaseNote?.releasedDate || '',
            released: releaseNote?.released || false,
            uploadedResources: releaseNote?.uploadedResources || [],
          }}
          isEditPage={true}
          editField={editField}
          setEditField={setEditField}
          submitHandler={submitHandler}
          isSubmitting={isFormSubmitting}
          errorMessage={errorMessage}
          errorCode={errorCode}
        />
      </LoadingPage>
    </PageOuterContainer >
  )
}